import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";

const SuperUserVersionData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();
  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data"> {(currentPage - 1) * 10 + (index + 1)}</td>
      <td className="table-each-row-data">{data?.employee_id ? data?.employee_id : '--'}</td>
      <td className="table-each-row-data">{data?.name ? data?.name : '--'}</td>
      <td className="table-each-row-data">{data?.email ? data?.email : '--'}</td>
      <td className="table-each-row-data"> {data?.mobile ? `+91 ${data?.mobile}` : '--'}</td>

      <td className="table-each-row-data">{data?.vendorVersion?.updatedByVendor?.name
        ? data?.vendorVersion?.updatedByVendor?.name
        : '--'}</td>
      <td className="table-each-row-data">
        {data?.updatedAt ? moment(data?.updatedAt).format("DD MMM YYYY, HH:MM A") : '--'}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/super-user/user/version-history-detail/${data.id}`)
            }
          >
            {"view"}
          </button>
        </div>
      </td>
    </tr>
  );
};

export default SuperUserVersionData;
